import React from "react";
import * as Styles from "./header.css";
import { Link } from "gatsby";

const Header = () => (
  <Styles.Header>
    <Styles.HeaderContainer>
      <Styles.StyledNav>
        Logo
        <Styles.NavBar>
        <Link to="/">
          <Styles.NavButton>
            Home
        </Styles.NavButton>
        </Link>
        <Link to="/login">
          <Styles.NavButton>
            Login
        </Styles.NavButton>
        </Link>
        <Link to="/register">
          <Styles.NavButton>
            Register
        </Styles.NavButton>
        </Link>
        </Styles.NavBar>
      </Styles.StyledNav>
    </Styles.HeaderContainer>
  </Styles.Header>
)


export default Header
